module.exports = __webpack_public_path__ + "static/media/achievement-show-some-neighbourly-love.9afd8f18.svg";